import { render, staticRenderFns } from "./WeighingRecord.vue?vue&type=template&id=21052308&scoped=true"
import script from "./WeighingRecord.vue?vue&type=script&lang=js"
export * from "./WeighingRecord.vue?vue&type=script&lang=js"
import style0 from "./WeighingRecord.vue?vue&type=style&index=0&id=21052308&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21052308",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21052308')) {
      api.createRecord('21052308', component.options)
    } else {
      api.reload('21052308', component.options)
    }
    module.hot.accept("./WeighingRecord.vue?vue&type=template&id=21052308&scoped=true", function () {
      api.rerender('21052308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sorting/WeighingRecord.vue"
export default component.exports